import axios from 'axios';
import {config} from '../shared/app.config';

const RESOURCE_NAME = '/languages';

export default {
    languages () {
      return axios.get(config.webApiBase + RESOURCE_NAME);
    }
}
